/*
 Render and unrender higher order component
 via https://github.com/react-toolbox/
*/
import React, { Component } from 'react'
import PropTypes from 'prop-types'

const ActivableRendererFactory = (options = { delay: 500 }) => (ActivableComponent) => { // eslint-disable-line
  return class ActivableRenderer extends Component {
    static propTypes = {
      isActive: PropTypes.bool.isRequired,
      children: PropTypes.any,
      delay: PropTypes.number
    };

    static defaultProps = {
      delay: options.delay
    }

    state = {
      isActive: this.props.isActive,
      rendered: this.props.isActive
    };

    componentWillReceiveProps(nextProps) {
      if (nextProps.isActive && !this.props.isActive) this.renderAndActivate()
      if (!nextProps.isActive && this.props.isActive) this.deactivateAndUnrender()
    }

    deactivateAndUnrender() {
      this.setState({ rendered: true, isActive: false }, () => {
        this.unrenderTimeout = setTimeout(() => {
          this.setState({ rendered: false })
          this.unrenderTimeout = null
        }, this.props.delay)
      })
    }

    renderAndActivate() {
      if (this.unrenderTimeout) {
        clearTimeout(this.unrenderTimeout)
      }
      this.setState({ rendered: true, isActive: false }, () => {
        setTimeout(() => this.setState({ isActive: true }), 20)
      })
    }

    render() {
      const { delay, ...others } = this.props // eslint-disable-line no-unused-vars
      const { isActive, rendered } = this.state
      return rendered
        ? <ActivableComponent {...others} isActive={isActive} />
        : null
    }
  }
}

export default ActivableRendererFactory



// WEBPACK FOOTER //
// ../src/components/ActivableRenderer/index.js